export default __webpack_public_path__ + "static/media/login-img4.fa3e0e03.png";